<template>
    <div
        class="qrcodeBox"
        style="
            width: 128px;
            height: 182px;
            background: #ecf6ff;
            border-radius: 12px;
            padding: 24px 32px;
            position: fixed;
            z-index: 99999;
            transform: translateY(-50%);
            top: 50%;
        "
        v-show="leftNumber > 700 && !IsMobile"
        :style="{ left: ' ' + leftNumber + 'px' }"
    >
        <vue-qr
            :text="qrContent"
            :size="126"
            :logoSrc="logoUrl"
            :logoSize="60"
            colorDark="#000"
            colorLight="#fff"
            :margin="10"
            errorCorrectionLevel="H"
            v-if="gameId && qrContent != ''"
        ></vue-qr>
        <img
            v-else
            style="width: 126px; height: 126px; display: block"
            src="../assets/img/qrcode.png"
            alt=""
        />

        <p
            style="
                margin-top: 12px;
                font-size: 16px;
                width: 150px;
                left: 50%;
                position: relative;
                margin-left: -75px;
                line-height: 22px;
                font-family: PingFang SC, PingFang SC-Regular;
                font-weight: 400;
                text-align: center;
                color: #000;
            "
        >
            扫码下载游民星空<br />海量游戏折扣享不停
        </p>
    </div>
</template>

<script>
import VueQr from "vue-qr";
export default {
    name: "qrcodeBox",
    components: { VueQr },
    data() {
        return {
            gameId: this.$utils.getQueryString("gameId"),
            sourceContentId: this.$utils.getQueryString("sourceContentId"),
            leftNumber: 0,
            IsMobile: true,
            qrContent: "",
            logoUrl: "//image.gamersky.com/webimg13/wap/2021/APP-ICON@3x.png",
        };
    },
    mounted() {
        if (this.gameId) {
            let appUrl = `https://app.gamersky.com/oth/versionupgrade/?gsGameId=${this.gameId}&gsAppAction=gouMaiYouXi&gsAppRef=daogouka`;
            if (this.sourceContentId) {
                appUrl += `&sourceContentId=${this.sourceContentId}`;
            }
            const appOpenUrl = `https://app.gamersky.com/toApp/index.html?url=${encodeURIComponent(
                appUrl
            )}&iOSUMKey=45YK7d&androidUMKey=3J6oOG`;
            this.getShortUrl(appOpenUrl);
        }
        this.handleWindowResize();
        this.IsMobile = this.$utils.browser.IsMobile();
        window.addEventListener("resize", this.handleWindowResize);
    },

    beforeDestroy() {
        window.removeEventListener("resize", this.handleWindowResize);
    },
    methods: {
        handleWindowResize() {
            this.leftNumber = (window.innerWidth - 750) / 2 + 750 + 40;
        },
        getShortUrl(url) {
            this.$ajax
                .post("//router.gamersky.com/@/urlMapping/forMap", {
                    originUrl: url,
                })
                .then((response) => {
                    if (!response.error) {
                        this.qrContent = response.info.shortUrl;
                    }
                    console.log(response);
                });
        },
    },
};
</script>
<style scoped></style>
